import { supabase } from '@/utils/supabase/client';

export const paymentService = {
  createSession: async (plan: string, companyId: string, amount?: number, billingInterval: 'month' | 'year' = 'month') => {
    try {
      const resolvedAmount = typeof amount === 'number' ? amount : (plan === 'pro' ? 7900 : 39900);
      const response = await supabase.functions.invoke('create-checkout-session', {
        body: {
          plan,
          company_id: companyId,
          amount: resolvedAmount,
          billing_interval: billingInterval,
        },
      });

      if (response.error) {
        throw new Error(response.error.message || 'Failed to create checkout session');
      }

      // The edge function returns { url: session.url }
      if (response.data?.url) {
        // FIXED: Safe redirect - check for window before accessing location
        if (typeof window !== 'undefined') {
          window.location.href = response.data.url;
        } else {
          // Fallback for non-browser environments (e.g., testing) - log or throw
          console.warn('Cannot redirect in non-browser environment. URL:', response.data.url);
          return response.data.url; // Return URL for manual handling
        }
        return response.data.url;
      } else {
        throw new Error('No checkout URL returned from server');
      }
    } catch (error) {
      console.error('Payment service error:', error);
      throw error;
    }
  },
};